/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import Step from '../../containers/disponent/step';

const StepsWrapper = styled.div`
	padding: 26px 35px 0 39px;
`;

const Steps = ({steps, handleSelect}) => (
    <StepsWrapper>
        {steps.map((step, index) => (
            <Step
                key={`task-reservation-step-${index}`}
                step={step}
                handleClick={handleSelect}
            />
        ))}
    </StepsWrapper>
);

export default Steps;



// WEBPACK FOOTER //
// ./src/containers/disponent/steps.js